import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme, { classic, width } = {}) => ({
  container: { width },
  fieldLabel: { fontWeight: 600 },
  required: { color: colors.gilead.primary1 },
  requiredWithGap: { marginLeft: '4px', color: colors.gilead.primary1 },
  disabled: {
    '&.MuiSvgIcon-root.MuiSelect-icon': {
      stroke: `${theme.palette.grey1} !important`,
      color: `${theme.palette.grey1} !important`,
    },
  },
  paper: {
    width: width || 'initial',
    backgroundColor: classic ? 'none' : theme.palette.lightGrey,
    borderRadius: 12,
    border: classic ? '1px solid #929A92' : 'none',
    maxHeight: '30vh',
    marginTop: 15,
    '& ul': {
      paddingBottom: 4,
      paddingTop: 4,
    },
    '& li': {
      whiteSpace: 'normal',
      height: 'auto',
    },
  },
  error: {
    color: colors.gilead.primary1,
    fontSize: 14,
  },
  selectPlaceholder: {
    color: theme.palette.grey1,
  },
  removeIcon: {
    cursor: 'pointer',
    position: 'absolute',
    right: theme.spacing(3.5),
    top: theme.spacing(1.5),
    zIndex: 1,
    fill: theme.palette.darkGrey,
  },
}));
